import { AvailabilityOutput, CalendarEventForDispatchFragment, FullAssetFragment, ViewDatesQuery } from "../../../generated/graphql.generated";

export type ScheduleView = 'resourceTimelineDay' | 'resourceTimelineWeek' | 'dayGridMonth';

export const initialScheduleState = {
  bookingSchedule: {
    start: undefined as string | undefined,
    end:  undefined as string | undefined,
    view: 'resourceTimelineDay' as ScheduleView,
    title: undefined as string | undefined,
    dayMaxEvents: 0 as 0 | false,
    assets: [] as FullAssetFragment[],
    events: [] as CalendarEventForDispatchFragment[],
    availability: [] as AvailabilityOutput[],
    viewDates: [] as ViewDatesQuery['viewDates'],
  },
};

export type BookingScheduleState = typeof initialScheduleState;
